<template>
    <div :class="`item ${isLast ? 'is-last' : ''} ${open ? 'open' : ''}`">
        <div class="title" @click="updateActiveId">
            <span class="text">
                <span class="fugaz-one-style">Q:</span>
                <span>{{ title }}</span>
            </span>
            <span class="open-icon icon">
                <img :src="openIcon" alt="icon" />
            </span>
            <span class="close-icon icon">
                <img :src="closeIcon" alt="icon" />
            </span>
        </div>
        <div class="toggle-box">
            <div class="content">
                <span class="fugaz-one-style">A:</span>
                <span>{{ content }}</span>
            </div>   
        </div>            
    </div>    
</template>

<script>
import closeIcon from '../../static/images/sectionQuestion/close.png';
import openIcon from '../../static/images/sectionQuestion/open.png';

export default {
    name: 'Item',
    props: ['title', 'content', 'index', 'isLast', 'open'],
    data: function() {
        return {
            open: false,
            closeIcon: closeIcon,
            openIcon: openIcon
        }
    },
    methods: {
        updateActiveId: function() {
            this.$emit('updateActiveId', this.index);
        }
    }
}
</script>

<style scoped 
       lang="scss">
    @import "../../static/styles/palette.scss";

    .item {
        display: flex;
        flex-direction: column;
        width: 100%;
        color: white;

        & .fugaz-one-style {
            font-family: "Fugaz One";
            font-size: 20px;
            line-height: 2;
            letter-spacing: 2px;
            margin-right: 8px;
        }

        & .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: calc(100% - 72px);
            font-family: "Roboto";
            font-weight: 700;
            font-size: 23px;
            letter-spacing: 3px;
            cursor: pointer;
            padding: 26px 0;
            box-sizing: border-box;
            margin: 0 auto;
            border-bottom: 1px solid white;
            font-size: 20px;
            font-weight: 500;
            line-height: 2;
            letter-spacing: 2px;

            & .text {
                display: flex;
                align-items: start;
            }

            & .icon {
                width: 32px;
                height: 32px;
                min-width: 32px;
                min-height: 32px;
                margin-left: 8px;

                & img {
                    width: 100%;
                    height: 100%;
                }

                &.open-icon {
                    display: block;
                }

                &.close-icon {
                    display: none;
                }
            }
        }

        & .toggle-box {
            position: relative;
            top: -1px;
            background-color: white;
            color: $darkGray;
            border-left: 12px solid $lightGray;
            max-height:0;
            transition: max-height 0.4s ease-out;
            overflow: hidden;

            & .content {
                display: flex;
                align-items: baseline;
                padding: 38px 32px 38px 24px;
                font-size: 20px;
                font-weight: 500;
                line-height: 2;
                letter-spacing: 1.67px;
            }
        }

        &.is-last{
            & .title {
                border: none;
            }

            & .toggle-box {
                top: 0;
            }
        }

        &.open {
            .toggle-box {
                max-height: 200px;
                transition: max-height 0.4s ease-out;
            }

            .title {
                .open-icon {
                    display: none;
                }

                .close-icon {
                    display: block;
                }
            }
        }
    }

    @media all and (max-width: 480px) {
        .item {
            & .fugaz-one-style {
                font-size: 14px;
                line-height: 1.71;
                letter-spacing: 1.4px;
            }

            & .title {
                align-items: start;
                width: calc(100% - 24px);
                padding: 24px 0;
                font-size: 14px;
                line-height: 1.71;
                letter-spacing: 1.4px;

                & .icon {
                    width: 24px;
                    height: 24px;
                    min-width: 24px;
                    min-height: 24px;
                }
           }

           & .toggle-box {
                border-left: 4px solid $lightGray;

                & .content {
                    display: flex;
                    align-items: baseline;
                    padding: 24px 12px 24px 8px;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.71;
                    letter-spacing: 1.4px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Item.vue?0b3c3ea3